import {
  AUTO_INSURANCE_VERTICAL,
  AUTO_INSURANCE_VERTICAL_CARD,
  AUTO_LOAN_VERTICAL,
  AUTO_LOAN_VERTICAL_CARD,
  CREDIT_CARD_VERTICAL,
  CREDIT_CARD_VERTICAL_CARD,
  HOME_INSURANCE_VERTICAL,
  HOME_INSURANCE_VERTICAL_CARD,
  HOME_LOAN_VERTICAL_CARD,
  LIFE_INSURANCE_VERTICAL,
  LIFE_INSURANCE_VERTICAL_CARD,
  PERSONAL_LOAN_VERTICAL,
  PERSONAL_LOAN_VERTICAL_CARD,
  BUSINESS_LOANS_VERTICAL_CARD,
  BUSINESS_LOANS_VERTICAL,
  CREDIT_CARD_VERTICAL_VRI,
  PERSONAL_LOAN_VERTICAL_VRI,
  AUTO_LOAN_VERTICAL_VRI,
  HOME_LOAN_VERTICAL_VRI,
  AUTO_INSURANCE_VERTICAL_VRI,
  HOME_INSURANCE_VERTICAL_VRI,
  LIFE_INSURANCE_VERTICAL_VRI,
  BUSINESS_LOANS_VERTICAL_VRI,
} from 'types/marketplaceTiles.constants';
import {
  HOME_LOAN_MARKETPLACE,
  BUSINESS_LOAN_MARKETPLACE,
} from 'types/mrph.pageName.constants';
import { HOME_INSURANCE_PERSONAL_URL } from 'types/mrph.routes.constants';
import { MORTGAGE_VERTICAL } from 'types/mrph.vertical.constants';

const metadataMap = {
  CREDIT_CARD: {
    text: 'Credit Cards',
    cardName: CREDIT_CARD_VERTICAL_CARD,
    url: '/offers?vertical=CREDIT_CARD',
    vertical: CREDIT_CARD_VERTICAL,
    location: 'offers-creditcards',
    vriName: CREDIT_CARD_VERTICAL_VRI,
  },
  PERSONAL_LOAN: {
    text: 'Personal Loans',
    cardName: PERSONAL_LOAN_VERTICAL_CARD,
    url: '/offers?vertical=PERSONAL_LOAN',
    vertical: PERSONAL_LOAN_VERTICAL,
    location: 'offers-personal-loan',
    vriName: PERSONAL_LOAN_VERTICAL_VRI,
  },
  AUTO_LOAN: {
    text: 'Auto Loans',
    cardName: AUTO_LOAN_VERTICAL_CARD,
    url: '/offers?vertical=AUTO_LOAN',
    vertical: AUTO_LOAN_VERTICAL,
    location: 'offers-auto',
    vriName: AUTO_LOAN_VERTICAL_VRI,
  },
  HOME_LOAN: {
    text: 'Home Loans',
    cardName: HOME_LOAN_VERTICAL_CARD,
    url: '/offers?vertical=HOME_LOAN',
    vertical: MORTGAGE_VERTICAL,
    location: HOME_LOAN_MARKETPLACE,
    vriName: HOME_LOAN_VERTICAL_VRI,
  },
  AUTO_INSURANCE: {
    text: 'Auto Insurance',
    cardName: AUTO_INSURANCE_VERTICAL_CARD,
    url: '/offers?vertical=AUTO_INSURANCE',
    vertical: AUTO_INSURANCE_VERTICAL,
    location: 'offers-insurance-auto',
    vriName: AUTO_INSURANCE_VERTICAL_VRI,
  },
  HOME_INSURANCE: {
    text: 'Home Insurance',
    cardName: HOME_INSURANCE_VERTICAL_CARD,
    url: HOME_INSURANCE_PERSONAL_URL,
    vertical: HOME_INSURANCE_VERTICAL,
    location: 'offers-insurance-home',
    vriName: HOME_INSURANCE_VERTICAL_VRI,
  },
  LIFE_INSURANCE: {
    text: 'Life Insurance',
    cardName: LIFE_INSURANCE_VERTICAL_CARD,
    url: '/offers?vertical=LIFE_INSURANCE',
    vertical: LIFE_INSURANCE_VERTICAL,
    location: 'offers-insurance-life',
    vriName: LIFE_INSURANCE_VERTICAL_VRI,
  },
  BUSINESS_LOAN: {
    text: 'Business',
    cardName: BUSINESS_LOANS_VERTICAL_CARD,
    url: '/offers?vertical=BUSINESS',
    vertical: BUSINESS_LOANS_VERTICAL,
    location: BUSINESS_LOAN_MARKETPLACE,
    vriName: BUSINESS_LOANS_VERTICAL_VRI,
  },
  BUSINESS: {
    text: 'Business',
    cardName: BUSINESS_LOANS_VERTICAL_CARD,
    url: '/offers?vertical=BUSINESS',
    vertical: BUSINESS_LOANS_VERTICAL,
    location: BUSINESS_LOAN_MARKETPLACE,
    vriName: BUSINESS_LOANS_VERTICAL_VRI,
  },
};

export default metadataMap;
